import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { LayoutService } from '../layout.service';
import { Router, RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { StsSelectors } from 'src/app/@store/selectors/sts.selectors';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { claimTypes } from 'src/app/appsettings';
import { TranslocoModule } from '@ngneat/transloco';
import { ConfigService } from 'src/app/service/config/config.service';
import { AuthService } from 'src/app/service/auth/auth.service';
import { HeaderActions } from 'src/app/@store/actions/header.actions';
import { HeaderSelectors } from 'src/app/@store/selectors/header.selectors';
import { AsyncPipe } from '@angular/common';
import { MPI_ID_QUERY_PARAM_NAME } from '../results.constants';

@Component({
  selector: 'app-right-sidebar',
  standalone: true,
  imports: [RouterLink, TranslocoModule, AsyncPipe],
  templateUrl: './right-sidebar.component.html',
  styleUrl: './right-sidebar.component.scss'
})
export class RightSidebarComponent implements OnInit, OnDestroy {

  private readonly store = inject(Store);

  private readonly router = inject(Router);

  private readonly authService = inject(AuthService);

  public readonly layoutService = inject(LayoutService);

  private readonly configService = inject(ConfigService);

  public readonly showRightSidebar = this.layoutService.showRightSidebar;

  public readonly wards$ = this.store.select(HeaderSelectors.getWards);

  public userEmail: string = '';

  public givenName: string = '';

  public familyName: string = '';

  public userPhone: string = '';

  public baseProfileUrl: string = '';

  public readonly mpiIdQueryParamName = MPI_ID_QUERY_PARAM_NAME;

  private readonly onDestroy$ = new Subject<void>();

  ngOnInit(): void {
    this.setupConfig();
    this.subscribeToUserInfo();
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  private setupConfig() {
    const { baseProfileUrl } = this.configService._envConfig;
    this.baseProfileUrl = baseProfileUrl;
  }

  public wardSwitch(mpiId: string) {
    this.showRightSidebar.set(false);
    this.router.navigate(['/results/category'], {
      queryParams: {
        [MPI_ID_QUERY_PARAM_NAME]: mpiId
      }
    });
  }

  private subscribeToUserInfo() {
    this.store
      .select(StsSelectors.getUserBasicInfo)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(({ givenName, familyName, claims, synlabId }) => {
        if (!claims || !synlabId || !givenName || !familyName) return;

        this.givenName = givenName;
        this.familyName = familyName;
        this.userEmail = claims.find(claim => claim.claimType === claimTypes.EMAIL)?.claimValue;
        this.userPhone = claims.find(claim => claim.claimType === claimTypes.PHONE)?.claimValue;

        this.store.dispatch(HeaderActions.getRelatedUsers({ synlabId: synlabId }));
      });
  }

  logout() {
    this.authService.startSignoutMainWindow()
  }

}
